package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Border.NONE
import com.downdogapp.Display.FLEX
import com.downdogapp.FontWeight.BOLD
import com.downdogapp.FontWeight.MEDIUM
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Size.AUTO
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.RedeemGiftViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.resources.image
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.ScreenWidth.PHONE

class RedeemGiftView(private val controller: RedeemGiftViewController) : TopLevelView(), View {

  override val root =
    controllerView {
      bg = background(image = Images.MEMBERSHIP)

      fg = foreground {
        centerHorizontally {
          div {
            screenWidthDependent { screendWidth ->
              width = px(if (screendWidth == PHONE) 330 else 500)
            }

            div {
              textAlign = CENTER
              marginTop = px(30)
              marginHorizontal = AUTO
              label(
                text = Strings.REDEEM_GIFT_VIEW_TITLE,
                fontSize = 24,
                fontWeight = MEDIUM
              ) {
                screenWidthDependent { screenWidth ->
                  fontSize = px(if (screenWidth == PHONE) 18 else 24)
                }
              }
            }

            div {
              screenWidthDependent { screenWidth ->
                width = px(if (screenWidth == PHONE) 200 else 280)
              }

              marginTop = px(20)
              marginHorizontal = AUTO
              display = FLEX
              justifyContent = SPACE_BETWEEN

              for (appType in controller.tiles) {
                controller.getImage(appType)?.let {
                  div {
                    img {
                      screenWidthDependent { screenWidth ->
                        width = px(if (screenWidth == PHONE) 34 else 44)
                        height = px(if (screenWidth == PHONE) 34 else 44)
                      }
                      image = it
                    }
                  }
                }
              }
            }

            div {
              marginTop = px(30)
              marginHorizontal = AUTO
              paddingHorizontal = px(30)
              label(
                text = Strings.REDEEM_GIFT_INSTRUCTIONS(controller.code, MANIFEST.email!!),
                fontSize = 16
              )
            }

            div {
              width = percent(100)

              div {
                paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
                paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

                button {
                  screenWidthDependent { screenWidth ->
                    height = if (screenWidth == PHONE) px(50) else ROUNDED_TEXT_BUTTON_HEIGHT_PX
                    fontSize = px(if (screenWidth == PHONE) 15 else 19)
                  }
                  marginTop = px(35)
                  textContent = Strings.REDEEM.uppercase()
                  width = percent(100)

                  borderRadius = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
                  border = NONE

                  fontFamily = FONT_FAMILY
                  fontWeight = BOLD

                  bgColor = Color.DOWN_DOG_BLUE
                  txtColor = Color.WHITE

                  onClick {
                    controller.redeemGift()
                  }
                }
              }
            }

            centerHorizontally {
              width = percent(100)

              div {
                width = px(300)
                borderRadius = px(4)
                screenWidthDependent { screenWidth ->
                  height = px(if (screenWidth == PHONE) 30 else 50)
                }
                marginVertical = px(10)

                centerInParent {
                  val cancelButton = textButton(
                    text = Strings.CANCEL,
                    fontSize = 20,
                    clickFn = controller::cancel
                  ) {
                    opacity = 0.8
                  }
                  screenWidthDependent { screenWidth ->
                    cancelButton.fontSize = px(if (screenWidth == PHONE) 14 else 20)
                  }

                  onClick {
                    controller.cancel()
                  }
                }

                onClick {
                  controller.cancel()
                }
              }
            }
          }
        }
      }
    }
}
